import React from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import ButtonPrimary from '../../../common/Buttons/ButtonPrimary';
import ButtonSecondary from '../../../common/Buttons/ButtonSecondary';
import { studentActions } from '../../../../redux/actions';

import {
  Column,
  Input,
  InputColumn,
  FullFlexCont,
  WhiteSpace,
  ContactForm,
} from '../../formStyledComponents';

const CourseToEdit = ({
  profile,
  setSelectedCourse,
  name,
  i,
}) => {

  const dispatch = useDispatch();

  const { register, handleSubmit } = useForm();

  const onSubmit = (data, e) => {
    e.preventDefault();
    const courses = _get(profile, 'otherExperience', []);
    const index = i;
    courses.splice(index, 1, data.name);
    dispatch(studentActions.save({ otherExperience: courses }));
    setSelectedCourse(null)
  };


  return (
    <>
      <ContactForm onSubmit={handleSubmit(onSubmit)}>

        <FullFlexCont justify="flex-end" padding="0" mobilePadding="0">

          <InputColumn
            width="100%"
            margin="0 auto 0 2rem"
            mobileMargin="0"
            mobileAlignCenter
          >
            <Input
              width="100%"
              mBottom="0"
              name="name"
              placeholder="competencia digital"
              ref={register({ required: true })}
              defaultValue={name}
              mobileMargin="0"
              mobileWidth="80%"
            />
          </InputColumn>


        </FullFlexCont>

        <FullFlexCont justify="space-between">

          <WhiteSpace height="1rem" />

          <Column width="46">
            <ButtonSecondary
              text="Atrás"
              onClick={() => setSelectedCourse(null)}
              margin="auto"
              fullWidth
            />
          </Column>

          <Column width="46">
            <ButtonPrimary
              type={2}
              text="Guardar"
              htmlType="submit"
              margin="auto"
              fullWidth
            />
          </Column>

        </FullFlexCont>

      </ContactForm>
    </>
  );
};

export default CourseToEdit;
